// Geo lookup via the edge Worker. Defaults to the most-conservative regime
// (gdpr) if the lookup fails — see BUILD_PLAN.md §5.3: "Default to the
// stricter regime if uncertain."

import type { ConsentRegime } from "./state";

interface GeoResponse {
  regime: ConsentRegime;
  country: string | null;
}

const GEO_URL = "/api/geo";

export async function detectRegime(): Promise<ConsentRegime> {
  try {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), 2000);
    const res = await fetch(GEO_URL, { signal: ctrl.signal, credentials: "omit" });
    clearTimeout(timer);
    if (!res.ok) return "gdpr";
    const body = (await res.json()) as Partial<GeoResponse>;
    return body.regime ?? "gdpr";
  } catch {
    return "gdpr";
  }
}
